export const SET_SELECTED_FRANCHISE = "SET_SELECTED_FRANCHISE";
export const RESET_FRANCHISE = "RESET_FRANCHISE";


export const setSelectedFranchise = (franchise) => ({
  type: SET_SELECTED_FRANCHISE,
  payload: franchise,
});

export const resetFranchise = () => ({
  type: RESET_FRANCHISE,
});
